import { jsx as _jsx } from "react/jsx-runtime";
const Cleaning = () => (_jsx("svg", Object.assign({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M10 5V4H11V1.19L8.62 0H3V4H4C4.00002 4.93429 3.81301 5.85912 3.45 6.72L4.37 7.11C4.78925 6.12694 5.00362 5.06872 5 4L6 6V7L3 10V16H12V13L10 5ZM5.68 3H4V1H8.38L10 1.81V3H9V5H6.68L5.68 3ZM11 15H4V10.54L7 7.54V6H9.25L11 13.07V15Z" }) })));
Cleaning.iconName = "cleaning";
Cleaning.iconCategory = "Product";
export default Cleaning;
